import { render, staticRenderFns } from "./CkeditorField.vue?vue&type=template&id=8456a1f6"
import script from "./CkeditorField.vue?vue&type=script&lang=js"
export * from "./CkeditorField.vue?vue&type=script&lang=js"
import style0 from "./CkeditorField.vue?vue&type=style&index=0&id=8456a1f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports